import merge from "lodash/merge";
import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import i18n from "../providers/localization/i18nProvider";
import * as mutationTypes from "../store/mutation-types";
import { fetchComponentTranslations } from "../providers/localization/ContentProvider";

export const checkIfLocaleExists = (arrayOfLocales, locale) => {
	return arrayOfLocales.includes(locale);
};

export const makeKeyValuePayload = (locale, catalog) => {
	const payload = [];
	payload.push(locale, catalog);
	return payload;
};

export const changeLanguage = async ({
	locale,
	vuexStore,
	adminRoute = false,
	tenantId = null
}) => {
	const catalog = vuexStore.getters.specificCatalog(locale);
	const dynamicCatalog = vuexStore.getters.dynamicCatalog(locale);
	const localeMessages = i18n.getLocaleMessage(locale);

	if (isEmpty(catalog) || isEmpty(dynamicCatalog)) {
		const { staticText, catalog } = await fetchComponentTranslations(
			vuexStore,
			locale,
			adminRoute,
			tenantId
		);

		vuexStore.commit(mutationTypes.ADD_CATALOG, [locale, staticText]);
		vuexStore.commit(mutationTypes.SET_DYNAMIC_CATALOG, [locale, catalog]);
	
		const combinedCatalogs = merge(staticText, catalog);
		i18n.locale = locale;
		i18n.setLocaleMessage(locale, combinedCatalogs);
	} else if (isEmpty(localeMessages)) {
		const combinedCatalogs = merge(cloneDeep(catalog), dynamicCatalog);
		i18n.locale = locale;
		i18n.setLocaleMessage(locale, combinedCatalogs);
	} else {
		i18n.locale = locale;
	}
	setLastLocale(locale, adminRoute, vuexStore);
};

export const checkForMissingCatalogs = (vuexStore, isAdmin = false) => {
	const locales = vuexStore.getters.tenantLocales;
	locales.forEach(locale => {
		const catalog = vuexStore.getters.specificCatalog(locale);
		const dynamicCatalog = vuexStore.getters.dynamicCatalog(locale);
		const components = [];

		if (isEmpty(catalog)) {
			components.push("staticText");
		}

		if (isEmpty(dynamicCatalog)) {
			components.push("catalog");
		}

		fetchComponentTranslations(vuexStore, locale, isAdmin).then(({ staticText, catalog }) => {
			vuexStore.commit(mutationTypes.ADD_CATALOG, [locale, staticText]);
			vuexStore.commit(mutationTypes.SET_DYNAMIC_CATALOG, [locale, catalog]);
		});
	});
};

export const updateCache = (vuexStore, locales) => {
	const cachedLocales = vuexStore.getters.tenantLocales;
	locales.forEach(element => {
		if (element.isDisabled === false) {
			if (!checkIfLocaleExists(cachedLocales, element.languageCode)) {
				vuexStore.commit(mutationTypes.ADD_LANGUAGE, makeKeyValuePayload(element.languageCode, element.language));
			}
		}
	});
};

export const setI18nInRouter = async (vuexStore, routerTo) => {
	const locale = routerTo && routerTo.includes("admin") ? await vuexStore.getters.lastLocaleAdmin : await vuexStore.getters.lastLocale;
	const catalog = await vuexStore.getters.specificCatalog(locale);
	i18n.locale = locale;
	i18n.setLocaleMessage(locale, catalog);
};

const setLastLocale = (locale, adminRoute, vuexStore) => {
	if (adminRoute) {
		vuexStore.commit(mutationTypes.SET_LAST_LOCALE_ADMIN, locale);
	} else {
		vuexStore.commit(mutationTypes.SET_LAST_LOCALE, locale);
	}
};
